<template>
  <!-- 未ログイン時に使用するレイアウト -->
  <div class="flex min-h-screen">
    <main class="flex flex-1 items-center justify-center"><slot /></main>
  </div>
</template>
